module.exports = __webpack_public_path__ + "static/media/Logo__Replit.0ee8f385.svg";